/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { number, object, string } from "prop-types";
import { fetch } from "Shared/config";
import { getFlag } from "Shared/helpers";
import defaultAvatar from "Shared/images/defaultAvatar.png";
import { useEffect } from "react";

export const Avatar = ({ user, size = 70, className }) => {
	const [avatar, setAvatar] = useState(defaultAvatar);

	useEffect(() => {
		if (user?.photo) {
			let avatar = `${fetch.base}${user?.photo}`;
			if (user?.photo.includes(".png") || user?.photo?.includes(".jpg") || user?.photo?.includes(".jpeg")) {
				avatar = `${fetch.base}${user?.photo}`;
			} else {
				avatar = `${fetch.base}${user?.photo}.png`;
			}
			setAvatar(avatar);
		}
	}, [user]);

	function calcScore(score) {
		const result = score?.score_sum / score?.score_count;
		if (!result) {
			return 0;
		}
		return result.toFixed();
	}
	const flag = user?.country?.iso_code ? getFlag(user?.country?.iso_code) : "";
	const score = calcScore(user?.score);
	// const avatar = user?.photo ? `${fetch.base}${user?.photo}` : defaultAvatar;

	return (
		<svg height={size} width={size} viewBox="0 0 100 100" className={className}>
			<defs>
				<pattern id="avatar" patternUnits="userSpaceOnUse" height="100" width="100">
					<image href={avatar} width="100" />
				</pattern>
				<pattern id="flag" patternUnits="userSpaceOnUse" height="33" width="33">
					<image href={flag} width="33" />
				</pattern>
			</defs>

			<circle r="46" fill="url(#avatar)" cx={50} cy={50} stroke="#20A39E" strokeWidth={"2"} />

			<circle r="16" fill={flag ? "url(#flag)" : "white"} cx={82} cy={82} stroke={"black"} strokeWidth={"2"} />
			<g>
				<rect rx={6} width={38} height={16} fill="#232A33" x={4} y={82} />
				<text x={23} y={96} fill="white" fontSize="17" textAnchor="middle">
					{score}
				</text>
			</g>
		</svg>
	);
};

Avatar.propTypes = {
	user: object,
	size: number,
	className: string,
};
